import React from 'react'

import { dealTeams } from '@/constants/dealTeams'
import BellSlash from '@/assets/img/bell-slash.svg'
import Image from 'next/image'

export function InitialsAvatar({ user, type }) {
  const { first_name, last_name, username } = user
  const isUserOutOfOffice = user?.data?.out_of_office ?? false
  const isUserMaximus = user?.first_name.toLowerCase().includes('maximus')

  return (
    <div
      className='ring-2 ring-white shadow-md w-7 h-7 rounded-full flex items-center justify-center relative'
      style={{ backgroundColor: dealTeams[type]?.color ?? '#000' }}
    >
      <span className='text-white text-sm text-center'>
        {first_name && last_name ? (
          <>{getInitials([first_name, last_name])}</>
        ) : (
          <>{getInitials([username])}</>
        )}
      </span>
      {!isUserMaximus && isUserOutOfOffice && (
        <Image
          src={BellSlash}
          alt='Out of office'
          className='absolute -top-1 -right-2 w-4 h-4 bg-white rounded-full shadow'
        />
      )}
    </div>
  )
}

const getInitials = (words: string[]) =>
  words.map((word) => word?.slice(0, 1).toUpperCase()).join('')
